<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="magnifying-glass-icon"
  >
    <!-- Magnifying glass circle -->
    <circle
      cx="10.875"
      cy="10.875"
      r="7.875"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <!-- Magnifying glass handle -->
    <path
      d="M16.44 16.44L21.56 21.56"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
// No props needed for this icon
</script>

<style lang="scss" scoped>
.magnifying-glass-icon {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
